var $60a71352491a8b6b$exports = {};
$(function() {
    'use strict';
    //------- Header Scroll Class  js --------//
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) $('.default-header').addClass('header-scrolled');
        else $('.default-header').removeClass('header-scrolled');
    });
    if ($('select').length && typeof $.fn.niceSelect === 'function') $('select').niceSelect();
    $('.img-pop-up').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });
    // Search Toggle
    $('#search-input-box').hide();
    $('#search').on('click', function() {
        $('#search-input-box').slideToggle();
        $('#search-input').focus();
    });
    $('#close-search').on('click', function() {
        $('#search-input-box').slideUp(500);
    });
    //  Counter Js
    $('.counter').counterUp({
        delay: 10,
        time: 1000
    });
    $('.play-btn').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    $('.popuar-course-carusel').owlCarousel({
        items: 4,
        loop: true,
        autoplay: true,
        margin: 30,
        nav: true,
        stagePadding: 60,
        navText: [
            "<i class='ti-arrow-left'></i>",
            "<i class='ti-arrow-right'></i>"
        ],
        responsive: {
            0: {
                items: 1,
                stagePadding: 0
            },
            575: {
                items: 2,
                stagePadding: 0
            },
            768: {
                items: 2,
                stagePadding: 0
            },
            992: {
                items: 3,
                stagePadding: 0
            },
            1200: {
                items: 3,
                stagePadding: 60
            },
            1440: {
                items: 4,
                stagePadding: 60
            }
        }
    });
    $('.video-carousel').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        margin: 30,
        nav: true,
        dots: false,
        navText: [
            "<i class='ti-arrow-left'></i>",
            "<i class='ti-arrow-right'></i>"
        ]
    });
    $('.testi-slider').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        margin: 30,
        nav: true,
        navText: [
            "<i class='ti-arrow-left'></i>",
            "<i class='ti-arrow-right'></i>"
        ]
    });
    // Google Map
    var init = function() {
        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 11,
            // The latitude and longitude to center the map (always required)
            center: new google.maps.LatLng(40.67, -73.94),
            // How you would like to style the map.
            // This is where you would paste any style found on Snazzy Maps.
            styles: [
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#e9e9e9'
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5'
                        },
                        {
                            lightness: 20
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff'
                        },
                        {
                            lightness: 17
                        }
                    ]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#ffffff'
                        },
                        {
                            lightness: 29
                        },
                        {
                            weight: 0.2
                        }
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff'
                        },
                        {
                            lightness: 18
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#ffffff'
                        },
                        {
                            lightness: 16
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f5f5f5'
                        },
                        {
                            lightness: 21
                        }
                    ]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#dedede'
                        },
                        {
                            lightness: 21
                        }
                    ]
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            visibility: 'on'
                        },
                        {
                            color: '#ffffff'
                        },
                        {
                            lightness: 16
                        }
                    ]
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            saturation: 36
                        },
                        {
                            color: '#333333'
                        },
                        {
                            lightness: 40
                        }
                    ]
                },
                {
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'transit',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f2f2f2'
                        },
                        {
                            lightness: 19
                        }
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#fefefe'
                        },
                        {
                            lightness: 20
                        }
                    ]
                },
                {
                    featureType: 'administrative',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#fefefe'
                        },
                        {
                            lightness: 17
                        },
                        {
                            weight: 1.2
                        }
                    ]
                }
            ]
        };
        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>
        var mapElement = document.getElementById('map');
        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, mapOptions);
        // Let's also add a marker while we're at it
        new google.maps.Marker({
            position: new google.maps.LatLng(40.67, -73.94),
            map: map,
            title: 'Snazzy!'
        });
    };
    if (document.getElementById('map')) google.maps.event.addDomListener(window, 'load', init);
    $(document).ready(function() {
        $('#mc_embed_signup').find('form').ajaxChimp();
    });
});


export {$60a71352491a8b6b$exports as default};
//# sourceMappingURL=repo.9de9c31c.js.map
